import {
  changeWorkflowStateProps,
  checkWorkFlowNameProps,
  handleRunTestProps,
  orderListProps,
  saveWorkFlowProps,
  workFlowDetailProps,
  workFlowFailList,
  WorkFlowForm,
  WorkFlowListData,
  workFlowListProps,
  WorkFlowRecordListData,
  WorkFlowRecordParams,
} from "@/api/workFlow/type"
import request, { formatRequest } from "@/utils/request"

const APIWorkFlow = {
  /**
   * 获取工作流列表
   */
  getWorkFlowList(params?: workFlowListProps) {
    return formatRequest<WorkFlowListData>(
      request.get("/go-api/v1/work_flow/list", { params }),
    )
  },

  /**
   * 自动同意工作流判断用户是否有账户余额和是否开启直接集成
   */
  getShopDirectLogistic(params?: workFlowListProps) {
    return formatRequest(
      request.get("/go-api/v1/work_flow/shop_direct_logistic", { params }),
    )
  },

  /**
   * 获取工作流失败列表
   */
  getWorkFlowFailList(params: workFlowFailList) {
    return formatRequest(
      request.get("/go-api/v1/work_flow/run_failed/log", { params }),
    )
  },

  /**
   * 获取工作流详情
   */
  getWorkFlowDetail(params: workFlowDetailProps) {
    return formatRequest(request.get("/go-api/v1/work_flow/detail", { params }))
  },
  /**
   * 获取工作流详情
   */
  getWorkFlowRecordList(params: WorkFlowRecordParams) {
    return formatRequest<WorkFlowRecordListData>(
      request.get("/go-api/v1/work_flow/run/log", { params }),
    )
  },

  /**
   * 获取工作流列表（无需参数）
   */
  getWorkFlowRuleOptions() {
    return formatRequest(request.get("/go-api/v1/work_flow/rule_options"))
  },

  /**
   * 工作流保存
   */
  saveWorkFlow(data: WorkFlowForm) {
    return formatRequest(request.post("/go-api/v1/work_flow/save", data), {
      success: {
        1000: t("SavedSuccessfully"),
      },
    })
  },

  /**
   * 工作流检测名称.action是否可用
   */
  checkWorkFlowName(params: checkWorkFlowNameProps) {
    return formatRequest(
      request.post("/go-api/v1/work_flow/check_flow", params),
    )
  },

  /**
   * 修改工作流状态
   * ids： 批量操作的工作流ID集
   * opt： 操作 1-active 2-turn off 3-delete(激活状态不删)
   */
  changeWorkflowState(params: {
    /**
     * 批量操作的工作流ID集
     */
    id: number
    /**
     * 操作 1-active 2-turn off 3-delete(激活状态不删)
     */
    opt: number
  }) {
    return formatRequest(
      request.post("/go-api/v1/work_flow/change_state", params),
      {
        success: {
          1000: t("OperationSuccessful"),
        },
      },
    )
  },

  /**
   * 修改工作流状态
   * ids： 批量操作的工作流ID集
   * opt： 操作 1-active 2-turn off 3-delete(激活状态不删)
   */
  handleRunTest(params: handleRunTestProps) {
    return formatRequest(request.post("/v1/workFlow/runTest", params))
  },

  /**
   * 获取订单列表
   */
  getOrderList(params: orderListProps) {
    return formatRequest(
      request.get("/go-api/v1/com/return/order/list", { params }),
    )
  },

  /**
   * 获取直接集成列表
   */
  getDirectIntegrations() {
    return formatRequest(request.get("/v1/directIntegrations"))
  },

  /**
   * 获取直接集成列表
   */
  sortWorkFlow(data: { kind: number; ids: number[] }) {
    return formatRequest(request.post("/go-api/v1/work_flow/sort", data), {
      success: {
        1000: t("OperationSuccessful"),
      },
    })
  },
}

export default APIWorkFlow
